import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import { configureRequestBody } from 'owa-folders/lib/services/findFolders';

const HEADER_EXPLICIT_LOGON_USER: string = 'X-OWA-ExplicitLogonUser';
const HEADER_ANCHOR_MAILBOX: string = 'X-AnchorMailbox';

export default function findSharedFolders(
    baseFolderIds: BaseFolderId[],
    principalSMTPAddress: string,
    indexedPageOffset: number
): Promise<FindFolderResponseMessage> {
    let requestBody = configureRequestBody(baseFolderIds, indexedPageOffset);
    return findFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        getExplicitUserHeaders(principalSMTPAddress)
    ).then(response => {
        // In the FindFolderAction, the first folder is the principal's root node.
        // The second folder is the principal's Inbox.
        // For shared folder scenario, when the delegate has access to the principal's root,
        // we should load all the folders visible to the delegate under the principal's root.
        // When the delegate only has access to the principal's Inbox, but not the root, the response of the first folder will be null.
        if (
            response.Body.ResponseMessages.Items[0] &&
            response.Body.ResponseMessages.Items[0].ResponseClass !== 'Success' &&
            response.Body.ResponseMessages.Items.length > 1
        ) {
            return response.Body.ResponseMessages.Items[1] as FindFolderResponseMessage;
        }

        return response.Body.ResponseMessages.Items[0] as FindFolderResponseMessage;
    });
}

function getExplicitUserHeaders(principalSMTPAddress: string) {
    return {
        headers: <any>{
            [HEADER_EXPLICIT_LOGON_USER]: principalSMTPAddress,
            [HEADER_ANCHOR_MAILBOX]: principalSMTPAddress,
        },
    };
}
